import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { detectLanguage, translateText } from '../utils/translator';
 
// Create a context for language management
export const LanguageContext = createContext({
  currentLanguage: 'fr',
  setLanguage: () => {},
  translateContent: async () => {},
  detectLanguageContent: async () => {},
});
 
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('fr');
  const translations = useRef({}); // Use useRef for caching translations
 
  // Function to set language and update localStorage
  const setLanguage = (lang) => {
    setCurrentLanguage(lang);
    localStorage.setItem('websiteLanguage', lang);
  };
 
  // Function to detect language of the text and set it as the current language
  const detectLanguageContent = async (text) => {
    try {
      const detectedLang = await detectLanguage(text);
      if (detectedLang) {
        setCurrentLanguage(detectedLang);
        localStorage.setItem('websiteLanguage', detectedLang);  // Save detected language in localStorage
      }
    } catch (error) {
      console.error('Language detection error:', error);
    }
  };
 
  // Function to translate content
  // Function to translate content
const translateContent = async (text, targetLang = currentLanguage) => {
  // Check if translation already exists in cache
  const cacheKey = `${text}-${targetLang}`;
  if (translations.current[cacheKey]) {
    return translations.current[cacheKey];
  }
 
  // Check for specific word translations
  const trimmedText = text.trim();

if (trimmedText === 'HOME') {
  if (targetLang === 'ar') {
    return 'الصفحة الرئيسية';
  }
    if (targetLang === 'fr') {
    return 'ACCUEIL';
  }
  return 'HOME';
}



if (trimmedText === 'PRODUCT') {
  if (targetLang === 'ar') {
    return 'المنتوج';
  }
    if (targetLang === 'fr') {
    return 'PRODUIT';
  }
  return 'PRODUCT';
}
if (trimmedText === 'Product') {
  if (targetLang === 'ar') {
    return 'المنتوج';
  }
    if (targetLang === 'fr') {
    return 'Produit';
  }
  return 'Product';
}

// if (trimmedText === 'REVOLUTIONIZING THE MATERIAL') {
//   if (targetLang === 'ar') {
//     return 'إحداث ثورة في تثمين المادة';
//   }
//   return 'REVOLUTIONIZING THE MATERIAL';
// }

if (trimmedText.toLowerCase() === 'revolutionizing the material') {
  const arabicText = 'إحداث ثورة في تثمين المادة';
  const frenchText = 'RÉVOLUTIONNER LA MATIÈRE';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}

if (trimmedText === '6315, Rameau Street - Montreal, Quebec H1P 1R7, Canada') {
  if (targetLang === 'ar') {
    return '6315، شارع رامو - مونتريال (كيبك) H1P1R7 - كندا';
  }
  if (targetLang === 'fr') {
    return '6315, rue Rameau - Montréal (Québec) H1P 1R7, Canada';
  }
  return '6315, Rameau Street - Montreal, Quebec H1P 1R7, Canada';
}

// if (trimmedText.toLowerCase() === '6315, rameau street - montreal, quebec h1p 1r7, canada') {
//   const arabicText = '6315، شارع رامو - مونتريال (كيبك) H1P1R7 - كندا';
//   const frenchText = '6315, Rameau Street - Montreal, Quebec H1P 1R7, Canada';

//   const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
//   const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
//   translations.current[cacheKey] = result;
//   console.log('Translation result:', result);
//   return result;
// }

if (trimmedText === '1016 Housing Units, Building D49 - No.26 - El Achour - Algiers - Algeria') {
  if (targetLang === 'ar') {
    return 'حي 1016 مسكن رقم 26، عمارة D49 - العاشور - الجزائر العاصمة - الجزائر';
  }
  if (targetLang === 'fr') {
    return '1016 Logements, Bâtiment D49 - N°26 - El Achour - Alger - Algérie';
  }
  return '1016 Housing Units, Building D49 - No.26 - El Achour - Algiers - Algeria';
}



if (trimmedText === 'Telephone :') {
  const arabicText = 'الهاتف :';
  const frenchText = 'Téléphone :';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}



// New condition for "Address :"
if (trimmedText === 'Address :') {
  const arabicText = 'العنوان :';
  const frenchText = 'Adresse :';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}
// if (trimmedText === 'Address') {
//   if (targetLang === 'ar') {
//     return 'العنوان';
//   }
//   return 'Address';
// }
if (trimmedText.toLowerCase() === 'oem africa') {
  const arabicText = 'OEM AFRICA';
  const frenchText = 'OEM AFRICA';
  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}

if (trimmedText === 'Get a quote') {
  const arabicText = 'اتصل بنا';
  const frenchText = 'Obtenir un devis';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}

if (trimmedText.toLowerCase() === 'events') {
  const arabicText = 'الفعاليات';
  const frenchText = 'ÉVÉNEMENTS';
  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}


if (trimmedText === 'OEM Africa LTD') {
  if (targetLang === 'fr') {
    return 'OEM AFRICA LTÉE';
  }
  return 'OEM Africa LTD';
}

if (trimmedText === 'OEM Africa LTD') {
  if (targetLang === 'ar') {
    return 'OEM AFRICA المحدودة';
  }
  return 'OEM Africa LTD';
}

if (trimmedText.toLowerCase() === 'turnkey systems') {
  if (targetLang === 'ar') {
    return 'الأنظمة الجاهزة';
  }
  if (targetLang === 'fr') {
    return 'SYSTÈMES CLÉS EN MAIN';
  }
  return 'TURNKEY SYSTEMS';
}


// if (trimmedText === 'Improved operational accuracy with our new flake sorter') {
//   if (targetLang === 'ar') {
//     return 'تحسين دقة العمليات مع فارز البلاستيك الجديد لدينا';
//   }
//     if (targetLang === 'fr') {
//     return 'Précision opérationnelle améliorée grâce à notre nouveau trieur de flocons';
//   }
//   return 'Improved operational accuracy with our new flake sorter';
// }
if (trimmedText.toLowerCase() === 'improved operational accuracy with our new flake sorter') {
  const arabicText = 'تحسين دقة العمليات مع فارز البلاستيك الجديد لدينا';
  const frenchText = 'Précision opérationnelle améliorée grâce à notre nouveau trieur de flocons';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}



if (trimmedText.toLowerCase() === 'This advanced system efficiently separates polypropylene flakes from polyethylene flakes, reducing CP2 levels in our feedstock') {
      const arabicText = 'يفصل هذا النظام المتقدم رقائق البولي بروبيلين عن رقائق البولي إيثيلين بكفاءة، مما يقلل من مستويات CP2 في المواد الأولية لدينا';
      const frenchText = 'Ce système avancé sépare efficacement les flocons de polypropylène des flocons de polyéthylène, réduisant les niveaux de CP2 dans notre matière première';

      const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
      const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
      translations.current[cacheKey] = result;
      return result;
    }

if (trimmedText.toLowerCase() === "this paragraph is an excerpt from a post on purecycle technologies' linkedin profile.".toLowerCase()) {
  const arabicText = 'هذه الفقرة مقتبسة من منشور PureCycle Technologies على حساب في LinkedIn.';
  const frenchText = 'Ce paragraphe est un extrait d’une publication sur le profil LinkedIn de PureCycle Technologies';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}

if (trimmedText.toLowerCase() === 'By submitting this form, I agree that the information entered will be used as part of the relationship that may develop with OEM Africa and its partners, fostering a mutually beneficial interaction between the parties involved.') {
  const arabicText = 'من خلال تقديم هذا النموذج، أوافق على أن المعلومات المدخلة ستُستخدم في إطار العلاقة التي قد تتطور مع شركة OEM Africa وشركائها، مما يعزز التفاعل المتبادل والمفيد بين الأطراف المعنية.';
  const frenchText = 'En soumettant ce formulaire, j’accepte que les informations saisies soient utilisées dans le cadre de la relation susceptible de se développer avec OEM Africa et ses partenaires, favorisant une interaction mutuellement bénéfique entre les parties concernées.';

  const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
  const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
  translations.current[cacheKey] = result;
  return result;
}


// if (
//   trimmedText.toLowerCase() ===
//   'revolutionize your material handling: our state-of-the-art self-cleaning electromagnets are a game-changer in material handling technology. powered by electricity, these magnets not only generate a strong magnetic field, but they also come with a unique self-cleaning function. say goodbye to manual maintenance, as our magnets effortlessly remove ferrous materials, ensuring uninterrupted efficiency. they are ideal for industries such as recycling and mining, where accuracy and reliability are paramount.'
// ) {
//   const arabicText = 'ثوّر طريقة مناولتك للمواد: إن مغناطيساتنا الكهربائية ذاتية التنظيف والمتقدمة تُمثل نقلة نوعية في تكنولوجيا مناولة المواد. تعمل بالكهرباء وتولّد مجالًا مغناطيسيًا قويًا، وتتميز بوظيفة التنظيف الذاتي الفريدة. وداعًا للصيانة اليدوية، حيث تزيل هذه المغناطيسات المواد الحديدية بسهولة لضمان كفاءة مستمرة. إنها مثالية لصناعات مثل إعادة التدوير والتعدين، حيث الدقة والموثوقية أمران حاسمان.';
  
//   const frenchText = 'Révolutionnez la manutention de vos matériaux : Nos électroaimants autonettoyants de pointe changent la donne dans la technologie de manutention. Alimentés par l’électricité, ces aimants génèrent un champ magnétique puissant et sont dotés d’une fonction autonettoyante unique. Fini l’entretien manuel : nos aimants éliminent sans effort les matériaux ferreux, assurant une efficacité ininterrompue. Ils sont idéaux pour des secteurs comme le recyclage et l’exploitation minière, où la précision et la fiabilité sont essentielles.';

//   const translation = targetLang === 'ar' ? arabicText : targetLang === 'fr' ? frenchText : trimmedText;
//   const result = { text: translation, dir: targetLang === 'ar' ? 'rtl' : 'ltr' };
//   // console.log( result)
//   translations.current[cacheKey] = result;
//   return result;
// }


  // Perform translation
  try {
    const translatedText = await translateText(text, targetLang);
 
    // Cache the translation
    translations.current[cacheKey] = translatedText;
 
    return translatedText;
  } catch (error) {
    console.error('Translation error:', error);
    return text; // Fallback to original text if translation fails
  }
};
 
 
 
  // Load language from localStorage on initial load
  useEffect(() => {
    const savedLanguage = localStorage.getItem('websiteLanguage');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);
 
  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      setLanguage,
      translateContent,
      detectLanguageContent
    }}>
      {children}
    </LanguageContext.Provider>
  );
};
 
// Custom hook for easy context usage
export const useLanguage = () => useContext(LanguageContext);
 
 
